import { ToastUtility } from '@syncfusion/ej2-react-notifications'

type ToastProps = {
  title?: string
  content: string
  type: 'success' | 'info' | 'danger' | 'warning'
}

// Custom hook zum anzeigen einer globalen Toast Message
const useToast = () => {
  const showToast = ({ title, content, type }: ToastProps) => {
    let icon

    switch (type) {
      case 'success':
        icon = 'e-circle-check'
        break
      case 'danger':
        icon = 'e-circle-close'
        break
      default:
        icon = 'e-circle-info'
    }

    ToastUtility.show({
      icon: `e-icons ${icon}`,
      content: content,
      cssClass: `e-toast-${type}`,
      timeOut: 5000,
      position: { X: 'Left', Y: 'Bottom' },
      width: 500,
      title: title,
    })
  }

  return { showToast }
}

export default useToast
